import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
};
export const mutations = {
  // GET_FILE({ context }, data) {
  //   state.resultDocument = Object.assign({}, data);
  // },
};
export const actions = {
  SAVE_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  EDIT_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.put(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  DELETE_DOCUMENTO({ commit }, id) { 
    return new Promise((resolve, reject) => {
      ApiService.delete(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GET_FILE_DOC({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      ApiService.getFile(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  DELETE_FILE_DOC({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      ApiService.put(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GET_DOCUMENTOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      // console.log(data);
      ApiService.get(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};

export const getters = {//leer datos
};
